import axios from 'axios'
import global from '@/global/variable.js'

// 获取货车列表
export function getList(data) {
  const url = global.requestUrl + '/truckInfo/list?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 创建货车信息
export function createOne(data) {
  const url = global.requestUrl + '/truckInfo/create'
  return axios.post(url, data)
}

// 更新货车信息
export function updateOne(data) {
  const url = global.requestUrl + '/truckInfo/update'
  return axios.post(url, data)
}

// 删除货车信息
export function deleteOne(data) {
  const url = global.requestUrl + '/truckInfo/delete/' + data.id
  return axios.get(url)
}

// 一键签退
export function unbindAll(data) {
  const url = global.requestUrl + '/truckInfo/unbound'
  return axios.get(url)
}

// 司机签到
export function bindOne(data) {
  const url = global.requestUrl + '/truckInfo/bindTruck?plateNumber=' + data.plateNumber + '&name=' + data.driver
  return axios.get(url)
}

// 司机签退
export function unbindOne(data) {
  const url = global.requestUrl + '/truckInfo/unboundTruck?plateNumber=' + data.plateNumber + '&name=' + data.driver
  return axios.get(url)
}
